import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import { AddToWorkflowDrawerContent } from 'modules/candidate-profile/components';
import { AddToWorkflowCandidate } from 'modules/candidate-profile/components/AddToWorkflowDrawerContent';

type UseAddToWorkflowDrawerProps = {
  candidates: AddToWorkflowCandidate[];
  onAddedToWorkflow?: () => Promise<void>;
};

export const useAddToWorkflowDrawer = () => {
  const { openDrawer } = useDrawerV2();

  const openAddToWorkflowDrawer = ({
    candidates,
    onAddedToWorkflow
  }: UseAddToWorkflowDrawerProps) => {
    openDrawer({
      title: 'Add to workflow',
      width: '700px',
      children: (
        <AddToWorkflowDrawerContent
          candidates={candidates}
          onAddedToWorkflow={onAddedToWorkflow}
        />
      )
    });
  };

  return { openAddToWorkflowDrawer };
};
